"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _resolveAndCallStrategy = _interopRequireDefault(require("../resolveAndCallStrategy"));

var makeMap = function makeMap(ctx, rule) {
  return /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref) {
      var _ref3, err, resultCtx, isApplicable, subjectOrCart, mapStrategy, partialWithoutFootprint, nextResultCtx;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref3 = (0, _slicedToArray2.default)(_ref, 4), err = _ref3[0], resultCtx = _ref3[1], isApplicable = _ref3[2], subjectOrCart = _ref3[3];

              if (isApplicable) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", [err, resultCtx, isApplicable, subjectOrCart]);

            case 3:
              mapStrategy = rule.map;
              _context.next = 6;
              return (0, _resolveAndCallStrategy.default)(ctx, 'map', mapStrategy, rule, subjectOrCart);

            case 6:
              partialWithoutFootprint = _context.sent;

              if (!(partialWithoutFootprint === undefined || partialWithoutFootprint === null)) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", [err, null, false, subjectOrCart]);

            case 9:
              nextResultCtx = (0, _extends2.default)({}, resultCtx, {
                partial: (0, _extends2.default)({}, partialWithoutFootprint, rule.noFootprint ? {} : {
                  ruleFootprint: {
                    ruleCode: rule.ruleCode,
                    ruleThread: rule.ruleThread
                  }
                })
              });
              return _context.abrupt("return", [err, nextResultCtx, isApplicable, subjectOrCart]);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var _default = makeMap;
exports.default = _default;